import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MuiContainer from "@mui/material/Container";
import { styled } from "@mui/material";
import { useAnnounceKitBanner } from "../../src/hooks/useAnnounceKitBanner";
import TopMenu from "../layouts/TopMenu";
import { userDetailsSelector } from "../store/slices/applicationFormSlice";
// Imported from its own file, not the AskFin index, so Ask Fin stays in a separate chunk loaded only when shown.
import { LazyAskFin } from "../components/AskFin/LazyAskFin";
import { useFeatureFlags } from "../utils/featureFlags";

const { innerWidth: width } = window;

const fullScreenWidthLayoutPaths = ["/application/", "/quote/"];

const Container = styled(MuiContainer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `${(width - 1200) / 2 - 300}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: -30,
  }),
}));

export default function AuthWrapper() {
  const location = useLocation();
  const isFullScreenWidthLayout = fullScreenWidthLayoutPaths.some((path) => location.pathname.startsWith(path));
  const isAnnounceKitBanner = useAnnounceKitBanner();
  const { open, isApplicationMenuOpen } = useSelector(userDetailsSelector);
  const { isAskFinEnabled } = useFeatureFlags();

  const announceKitBannerHeight = isAnnounceKitBanner?.status ? (isAnnounceKitBanner?.height || 0) + 80 : 84;

  const defaultApplicationLayoutMargin = !isApplicationMenuOpen
    ? `${announceKitBannerHeight}px auto 0 80px`
    : "84px auto 0";

  return (
    <>
      <TopMenu open={open} />
      <Container
        open={open}
        maxWidth={isFullScreenWidthLayout ? false : "xl"}
        style={{
          borderRadius: "4px",
          margin: isFullScreenWidthLayout ? "64px auto 0" : defaultApplicationLayoutMargin,
          padding: isFullScreenWidthLayout ? 0 : "0 20px",
        }}
      >
        <Outlet />
      </Container>
      {isAskFinEnabled() && <LazyAskFin />}
    </>
  );
}
